import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-eng-desk",
  "use": "icon-soc-eng-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-eng-desk\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M512 160c128 96 192 256 192 384 0 64-24 128-64 176l-128 80-128-80c-40-48-64-112-64-176 0-128 64-288 192-384z\" /><circle cx=\"512\" cy=\"448\" r=\"64\" fill=\"#fff\" /><path d=\"M384 720l-64 144h128l64-96-128-48zm256 0l64 144H576l-64-96 128-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-eng-desk.svg
// module id = KcL8
// module chunks = 546